export default __webpack_public_path__ + "static/ay-support-content-submit-ticket-0ddaa49f00eaeab2fcccb922269f1e57.svg";